import { render, staticRenderFns } from "./AddSequenceToContactForm.vue?vue&type=template&id=638cf40a&scoped=true"
import script from "./AddSequenceToContactForm.vue?vue&type=script&lang=js"
export * from "./AddSequenceToContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638cf40a",
  null
  
)

export default component.exports